<template>
    <div>
        <h1 class="display-heading">Received Payments</h1>

        <div id="searchAccordion" role="tablist">
            <div class="card mb-4">
                <a class="card-header filter-collapse-header" role="tab"  id="headingOne" data-toggle="collapse" href="#searchAccordionContent">
                    <p class="mb-0">
                        <i class="fa fa-search" aria-hidden="true"></i> Search Payments
                    </p>
                </a>
                <div id="searchAccordionContent" class="collapse" role="tabpanel" aria-labelledby="headingOne" data-parent="#searchAccordion">
                    <div class="card-body">
                        <form @submit.prevent="searchFilter">
                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <label>Payment ID</label>
                                    <input type="text" class="form-control" v-model="search.paymentId" />
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <label>Payment Received From Date (Optional)</label>
                                    <input type="text" name="paymentConfirmedFromDate" data-vv-as="payment received from date"
                                        data-vv-validate-on="blur" v-model="search.paymentConfirmedFromDate"
                                        v-mask="'##/##/####'" v-validate="'date_format:DD/MM/YYYY'" placeholder="DD/MM/YYYY"
                                        :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('paymentConfirmedFromDate')
                            }" />

                                    <div v-show="validationErrors.has('paymentConfirmedFromDate')" class="invalid-feedback">
                                        {{ validationErrors.first('paymentConfirmedFromDate') }}
                                    </div>
                                </div>

                                <div class="form-group col-md-6">
                                    <label>Payment Received To Date (Optional)</label>
                                    <input type="text" name="paymentConfirmedToDate" data-vv-as="payment received to date"
                                        data-vv-validate-on="blur" v-model="search.paymentConfirmedToDate" v-mask="'##/##/####'"
                                        v-validate="'date_format:DD/MM/YYYY'" placeholder="DD/MM/YYYY" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('paymentConfirmedToDate')
                            }" />

                                    <div v-show="validationErrors.has('paymentConfirmedToDate')" class="invalid-feedback">
                                        {{ validationErrors.first('paymentConfirmedToDate') }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <label>Payment Type</label>
                                    <select class="form-control" v-model="search.paymentType">
                                        <option v-for="(status, index) in paymentTypes" :key="index" :value="status.value">
                                            {{status.text}}
                                        </option>
                                    </select>
                                </div>

                                <div class="form-group col-md-6">
                                    <label>Payment Status</label>
                                    <select class="form-control" v-model="search.paymentStatus">
                                        <option v-for="(status, index) in paymentStatuses" :key="index"
                                            :value="status.value">
                                            {{status.text}}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <div class="form-check">
                                        <label class="form-check-label d-flex">
                                            <input class="form-check-input" type="checkbox" v-model="search.isNonZero">
                                            <div class="ml-2" style="margin-top:-3px">Show Non-zero amount only</div>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="searchFilter">
                                    Search Payouts
                                </button>
                                <button type="button" class="btn btn-secondary" @click="resetFilter">
                                    Reset Search
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div ref="tableSection">
            <div class="table-responsive">
                <table ref="listTable" class="table table-hover">
                    <colgroup>
                        <col width="50">
                        <col width="150">
                        <col width="150">
                        <col width="100">
                        <col width="150">
                        <col width="140">
                        <col>
                        <col width="80">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Payment ID</th>
                            <th>Received Date</th>
                            <th>Status</th>
                            <th>Payment Type</th>
                            <th>Amount (RM)</th>
                            <th>Payee Name</th>
                            <th>View</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(payout, index) in payoutList" :key="index">
                            <td>{{((pagination.currentPage - 1) *pagination.pageSize ) + index + 1}}</td>
                            <td>
                                <div>{{ payout.paymentId }}</div>
                                <div v-if="payout.isTelehealthConsultation">(Consultation ID: {{ payout.consultationId }})</div>
                                <div v-else-if="payout.isPrescription">(Prescription ID: {{ payout.prescriptionId }})</div>
                                <div v-else-if="payout.isClinicConsultation">(Consultation ID: {{ payout.consultationId }})</div>
                            </td>
                            <td class="text-nowrap">
                                <template v-if="payout.confirmedDate">
                                <div>
                                    {{ convertToUserReadableDate(payout.confirmedDate) }}
                                </div>
                                <div>
                                    {{ convertToUserReadableTime(payout.confirmedDate) }}
                                </div>
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </td>
                            <td>{{ payout.paymentStatus }}</td>
                            <td>{{ payout.paymentType }}</td>
                            <td>
                              {{ payout.amount}}
                            </td>
                            <td>
                                {{ payout.payeeName }}
                            </td>
                            <td>
                                <router-link :to="{'name': 'admin-received-payment-detail', 'params': {'paymentId': payout.paymentId }}">
                                    View
                                </router-link>
                            </td>
                        </tr>
                        <tr v-show="payoutList.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{isTableLoading ? "Loading Data": "No Data"}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <pagination v-model="pagination.currentPage" :totalPages="pagination.totalPages"
                :scrollPosition="pagination.scrollPosition">
            </pagination>
        </div>
    </div>
</template>

<script>
import { convertToUserReadableDate, convertToUserReadableTime, convertDateToIso8601 } from '@/utilities';
import pagination from '@/components/pagination';
import {
    mask
} from 'vue-the-mask';
export default {
    'name': 'PartnerPayout',
    'components': {
        pagination
    },
    'directives': {
        mask
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage (val) {
            if (!this.isTableLoading) {
                this.$nextTick(() => {
                    this.getPayouts();
                });
            }
        }
    },
    data () {
        return {
            'search': {
                'paymentConfirmedFromDate': null,
                'paymentConfirmedToDate': null,
                'paymentStatus': -1,
                'paymentType': 0,
                'isNonZero': true,
                'paymentId': null
            },
            'disbursementStatuses': [{
                'text': 'All',
                'value': -1
            },
            {
                'text': 'Disbursed',
                'value': 1
            },
            {
                'text': 'Outstanding',
                'value': 0
            }
            ],
            'paymentTypes': [
                {
                    'text': 'All',
                    'value': 0
                },
                {
                    'text': 'Consultations',
                    'value': 1
                },
                {
                    'text': 'Prescriptions',
                    'value': 2
                },
                {
                    'text': 'Company Credit Topups',
                    'value': 3
                },
                {
                    'text': 'Clinic Consultations',
                    'value': 4
                },
                {
                    'text': 'Medicine Delivery',
                    'value': 5
                },
                {
                    'text': 'Clinic Prescription',
                    'value': 6
                }
            ],
            'paymentStatuses': [
                {
                    'text': 'All',
                    'value': -1
                },
                {
                    'text': 'Received',
                    'value': 1
                },
                {
                    'text': 'Confirmed',
                    'value': 100
                },
                {
                    'text': 'Cancelled',
                    'value': 999
                },
                {
                    'text': 'Refunded',
                    'value': 998
                },
                {
                    'text': 'Refund Fail',
                    'value': 997
                }
            ],
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'payoutList': []
        };
    },
    mounted () {
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.add('wide-version');

        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window
                .scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getPayouts();
    },
    destroyed () {
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.remove('wide-version');
    },
    'methods': {
        convertToUserReadableDate (date) {
            return convertToUserReadableDate(date);
        },
        convertToUserReadableTime (date) {
            return convertToUserReadableTime(date);
        },
        getPayouts () {
            this.$validator.validateAll().then((isFormValid) => {
                if (isFormValid) {
                    this.payoutList = [];
                    this.isTableLoading = true;
                    let query = {
                        'p': this.pagination.currentPage,
                        'ps': this.pagination.pageSize,
                        'fd': this.search.paymentConfirmedFromDate ? convertDateToIso8601(this.search.paymentConfirmedFromDate) : null,
                        'td': this.search.paymentConfirmedToDate ? convertDateToIso8601(this.search.paymentConfirmedToDate) : null,
                        'pt': this.search.paymentType,
                        'pss': this.search.paymentStatus,
                        'inz': this.search.isNonZero,
                        'pi': this.search.paymentId
                    };

                    this.axios.post('PaymentList/GetReceivedPayments', query).then(({ data }) => {
                        this.isTableLoading = false;
                        let pagedResult = data.data;

                        this.pagination.currentPage = pagedResult.p;
                        this.pagination.totalPages = pagedResult.c;

                        let list = pagedResult.l;
                        this.payoutList = list.map((payout) => {
                            let paymentType = 'Others';

                            switch (payout.pt) {
                            case 1:
                                paymentType = 'Consultation';
                                break;
                            case 2:
                                paymentType = 'Prescription';
                                break;
                            case 3:
                                paymentType = 'Company Credit Topup';
                                break;
                            case 4:
                                paymentType = 'Clinic Consultation';
                                break;
                            case 5:
                                paymentType = 'Medicine Delivery';
                                break;
                            case 6:
                                paymentType = 'Clinic Medicine Purchase';
                                break;
                            }

                            let paymentStatus = this.paymentStatuses.find((s) => s.value === payout.ps);

                            return {
                                'paymentId': payout.psids,
                                'confirmedDate': payout.rd,
                                'amount': payout.am.toFixed(2),
                                'paymentStatus': paymentStatus ? paymentStatus.text : 'Unknown',
                                'paymentType': paymentType,
                                'payeeName': payout.pn,
                                'isTelehealthConsultation': payout.pt === 1,
                                'isPrescription': payout.pt === 2,
                                'isClinicConsultation': payout.pt === 4,
                                'consultationId': payout.consultationId,
                                'prescriptionId': payout.prescriptionId
                            };
                        });
                    });
                }
            });
        },
        resetFilter () {
            this.search.paymentConfirmedFromDate = null;
            this.search.paymentConfirmedToDate = null;
            this.search.disbursementFromDate = null;
            this.search.disbursementToDate = null;
            this.search.disbursementStatus = -1;
            this.search.paymentType = 0;

            this.pagination.currentPage = 1;

            this.getPayouts();
        },
        searchFilter () {
            this.pagination.currentPage = 1;

            this.getPayouts();
        }
    }
};

</script>
